/** Συντακτικό σφάλμα, με θέση στον πηγαίο κώδικα για εμφάνιση στον μαθητή. */
export class ParseError extends Error {
  readonly line: number;
  readonly column: number;

  constructor(message: string, line: number, column: number) {
    super(message);
    this.name = 'ParseError';
    this.line = line;
    this.column = column;
  }
}
